




























import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import TipoEvaluacion from '../../../models/evaluacion/tipoEvaluacion.model';
import BaseRepository from '@/core/HttpResources/BaseRepository';

@Component
export default class BaseQuestionType extends BaseVue {
  protected id: number|null = null;
  protected loading = false;
  protected repository!: BaseRepository<TipoEvaluacion>;
  protected name: any = '';
  protected model: TipoEvaluacion | any = null;

  created() {
    this.id = Number.parseInt(this.$route.params.id);
    if (this.hasParent && this.model == null) {
      this.repository = new BaseRepository<TipoEvaluacion>("TipoEvaluacion");
      this.getData();
    }
  }

  async getData() {
    try {    
      if(this.id) {
        this.model = await this.repository.getById(this.id);
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
    }
  }

  get hasParent() {
    return !!this.$route.params.id;
  }

  @Watch('model')
  onModelChange() {
    if (this.model) this.name = this.hasParent && this.model ? this.model.titulo : "---";
  }

  gotToList() {
    this.$router.push("/EvaluationType");
  }

}
